import { IValidationItem } from "../../model";
export class ValidationItem implements IValidationItem {
  public func: (eventValue?: string) => boolean;
  public validationMessage: string;
  constructor(
    func: (eventValue?: string) => boolean,
    validationMessage: string
  ) {
    this.func = func;
    this.validationMessage = validationMessage;
  }
}
